import { formatURIComponent } from './utils'

export default (instance:string) => {

    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}&instance=${instance}`
    }

    return [{
        pageLayout: 'tabs',
        slogan: '华美服务 = 咨询服务 + 华美云 + 尽管问',
        pageTitle: '品牌引进',
        pageTitleIcon: '',
        background_img: '/backgrounds/sunny.jpg',
        description: `华美从市场匹配度分析到品牌谈判落地，帮助业主甄选最优合作方案。很多业主常因缺乏专业评估而陷入品牌定位偏差、特许条款不利或管理费结构不合理等困境，导致后期经营被动。华美凭借与酒管深度的合作资源及丰富的谈判经验，确保业主获取最具竞争优势的品牌合作方案。`,
        icons: [
            {
                name: '品牌引进',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('/内容文件/华美/华美简介/2.品牌引进.pdf'),
                path: "四库赋能-酒店建设/品牌引进/成功案例"
            },
            {
                name: '华美项目',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('华美项目'),
                path: "四库赋能-酒店建设/品牌引进/华美项目"
            },
            {
                name: '数据赋能',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店建设/品牌引进/数据赋能'),
                path: "四库赋能-酒店建设/品牌引进/数据赋能"
            },
            {
                name: '全球案例',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店建设/品牌引进/全球案例/全球案例（品牌引进）.xlsx'),
                path: "四库赋能-酒店建设/品牌引进/全球案例"
            },
            {
                name: '预警问题',
                img: '/icons/工具库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店建设/品牌引进/预警问题/预警问题（品牌引进）.xlsx'),
                path: "四库赋能-酒店建设/品牌引进/预警问题"
            }
        ]
    }]
}